import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center`
export const Subheading = tw.h5`bg-primary-100 text-[1.5rem] font-semibold bg-opacity-25 text-primary-500 mx-auto rounded-full px-6 py-1 mb-4`
